import { breakpoints } from "@config/theme"
import styled from "styled-components"

export const Container = styled.div`
  display: flex;
  flex-direction: column-reverse;

  @media screen and (min-width: ${breakpoints.small}) {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 1rem;
    margin-top: 2rem;
  }
`

export const Column = styled.div`
  width: 100%;
  max-width: 15.5rem;

  &:nth-of-type(2) {
    margin-bottom: 2.5rem;

    @media screen and (min-width: ${breakpoints.small}) {
      margin-bottom: 0;
    }
  }
`
